import { images } from '../constants';

const products = [ 
    {
        id: 1,
        image: images.product1Gallery1,
        name: "Driving Shoes",
        price: 120,
        disprice: 0,
        stock: 5,
        content:
            "Step into comfort and style with our premium Driving Shoes, designed for maximum grip and durability. These shoes offer a perfect blend of flexibility and support, ensuring a smooth driving experience.",
        description:
            "Our Driving Shoes are an essential addition for taxi drivers and frequent travelers. With a non-slip sole and breathable design, these shoes ensure stability and ease during long drives. The sleek and professional look makes them suitable for both work and casual wear.",
        category: ["Driving Gear", "Car Accessories"],
        tags: ["Shoes", "Kit", "Cap"],
        gallery: {
            image1: images.product1Gallery1,
            image2: images.product1Gallery2,
            image3: images.product1Gallery3,
            image4: images.product1Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "Premium Leather & Rubber Sole" },
            { id: 2, title: "Sizes Available", content: "US 6 - US 12" },
            { id: 3, title: "Grip", content: "Anti-Slip & Shock Absorbent" },
            { id: 4, title: "Breathability", content: "Mesh Lining for Ventilation" },
        ],
        comments: [
            {
                id: 1,
                image: images.product1Review1,
                name: "James Parker",
                date: "July 20, 2024",
                rating: 5,
                content: "Extremely comfortable for long drives! The grip is excellent.",
            },
            {
                id: 2,
                image: images.product1Review2,
                name: "Emma Wilson",
                date: "July 25, 2024",
                rating: 4.7,
                content: "Very stylish and durable. Great for everyday driving!",
            },
        ],
    },
    {
        id: 2,
        image: images.product2Gallery1,
        name: "First Aid Kit",
        price: 50,
        disprice: 45,
        stock: 10,
        content:
            "Be prepared for emergencies with our compact and fully stocked First Aid Kit. Designed for taxi drivers and travelers, this kit includes essential medical supplies to handle minor injuries and first-aid situations while on the road.",
        description:
            "Our First Aid Kit is an essential safety companion for any taxi or vehicle. Packed with bandages, antiseptics, medical tape, and other essentials, it ensures quick and effective treatment during emergencies. The compact and durable case makes it easy to store and access when needed.",
        category: ["Emergency Kit", "Car Accessories"],
        tags: ["Kit", "Battery", "Extinguisher"],
        gallery: {
            image1: images.product2Gallery1,
            image2: images.product2Gallery2,
            image3: images.product2Gallery3,
            image4: images.product2Gallery4,
        },
        addInfo: [
            { id: 1, title: "Contents", content: "Bandages, Antiseptic Wipes, Gauze Pads, Scissors, Medical Tape, Gloves, and More" },
            { id: 2, title: "Case Material", content: "Durable Waterproof Plastic" },
            { id: 3, title: "Portability", content: "Compact & Lightweight for Easy Storage" },
            { id: 4, title: "Usage", content: "Ideal for Taxi Drivers, Road Trips, and Emergency Preparedness" },
        ],
        comments: [
            {
                id: 1,
                image: images.product2Review1,
                name: "James Parker",
                date: "July 20, 2024",
                rating: 5,
                content: "A must-have for any driver! Compact, well-stocked, and easy to use.",
            },
            {
                id: 2,
                image: images.product2Review2,
                name: "Emma Wilson",
                date: "July 25, 2024",
                rating: 4.8,
                content: "Great quality and perfect for emergencies on the road. Highly recommend!",
            },
        ],
    },
    {
        id: 3,
        image: images.product3Gallery1,
        name: "Driver Cap",
        price: 30,
        disprice: 25,
        stock: 3,
        content:
            "Complete your professional taxi driver look with our stylish and comfortable Driver Cap. Designed for all-day wear, this cap offers a classic design and a perfect fit, making it ideal for taxi drivers who want to maintain a polished and professional appearance.",
        description:
            "Our Driver Cap is crafted from high-quality, breathable fabric to ensure maximum comfort. With an adjustable fit and durable stitching, it's designed to last while keeping you looking sharp on the road. Ideal for taxi and chauffeur drivers looking to enhance their uniform.",
        category: ["Driving Gear", "Car Accessories"],
        tags: ["Cap", "Kit", "Covers"],
        gallery: {
            image1: images.product3Gallery1,
            image2: images.product3Gallery2,
            image3: images.product3Gallery3,
            image4: images.product3Gallery4,
        },
        addInfo: [
            { id: 1, title: "Material", content: "High-Quality Cotton Blend" },
            { id: 2, title: "Fit", content: "Adjustable Strap for Custom Fit" },
            { id: 3, title: "Breathability", content: "Lightweight & Ventilated for Comfort" },
            { id: 4, title: "Usage", content: "Ideal for Taxi Drivers & Chauffeurs" },
        ],
        comments: [
            {
                id: 1,
                image: images.product3Review1,
                name: "James Parker",
                date: "July 20, 2024",
                rating: 5,
                content: "Great quality cap! Comfortable fit and adds a professional touch to my uniform.",
            },
            {
                id: 2,
                image: images.product3Review2,
                name: "Emma Wilson",
                date: "July 25, 2024",
                rating: 4.8,
                content: "Stylish and comfortable. Looks great and fits well!",
            },
        ],
    },
    {
        id: 4,
        image: images.product4Gallery1,
        name: "Bluetooth Speaker",
        price: 80,
        disprice: 0,
        stock: 0,
        content:
            "Enhance your taxi rides with our premium Bluetooth Speaker, delivering high-quality sound and seamless connectivity. Designed for drivers who love music on the go, this speaker ensures clear audio for calls and entertainment while on the road.",
        description:
            "Our Bluetooth Speaker features superior sound quality, long battery life, and easy wireless pairing. Compact and portable, it fits perfectly in your taxi, providing crystal-clear audio and hands-free functionality. Stay connected and entertained with this must-have driver accessory.",
        category: ["Tech Gadgets", "Car Accessories"],
        tags: ["Speaker", "GPS", "Holder"],
        gallery: {
            image1: images.product4Gallery1,
            image2: images.product4Gallery2,
            image3: images.product4Gallery3,
            image4: images.product4Gallery4,
        },
        addInfo: [
            { id: 1, title: "Connectivity", content: "Bluetooth 5.0" },
            { id: 2, title: "Battery Life", content: "Up to 12 Hours Playtime" },
            { id: 3, title: "Sound Quality", content: "Crystal-Clear Audio with Deep Bass" },
            { id: 4, title: "Portability", content: "Compact & Lightweight Design" },
        ],
        comments: [
            {
                id: 1,
                image: images.product4Review1,
                name: "James Parker",
                date: "July 20, 2024",
                rating: 5,
                content: "Great sound quality and long battery life! Perfect for my taxi rides.",
            },
            {
                id: 2,
                image: images.product4Review2,
                name: "Emma Wilson",
                date: "July 25, 2024",
                rating: 4.9,
                content: "Compact and easy to use. Makes my rides more enjoyable!",
            },
        ],
    },
    {
        id: 5,
        image: images.product5Gallery1,
        name: "Engine Oil",
        price: 50,
        disprice: 45,
        stock: 15,
        content:
            "Keep your taxi running smoothly with our high-performance Engine Oil. Designed for optimal engine protection, it enhances fuel efficiency and prolongs engine life, ensuring a reliable and smooth ride.",
        description:
            "Our premium Engine Oil is formulated to reduce wear and tear, prevent sludge buildup, and improve overall engine performance. Suitable for all types of taxi engines, it provides excellent lubrication, ensuring smooth operation in various driving conditions.",
        category: ["Vehicle Maintenance", "Car Accessories"],
        tags: ["Oil", "Battery", "Kit"],
        gallery: {
            image1: images.product5Gallery1,
            image2: images.product5Gallery2,
            image3: images.product5Gallery3,
            image4: images.product5Gallery4,
        },
        addInfo: [
            { id: 1, title: "Viscosity", content: "5W-30" },
            { id: 2, title: "Performance", content: "Enhances Engine Efficiency" },
            { id: 3, title: "Protection", content: "Prevents Wear & Sludge Buildup" },
            { id: 4, title: "Compatibility", content: "Suitable for All Taxi Engines" },
        ],
        comments: [
            {
                id: 1,
                image: images.product5Review1,
                name: "James Parker",
                date: "July 20, 2024",
                rating: 5,
                content: "Top-quality engine oil! My taxi runs much smoother now.",
            },
            {
                id: 2,
                image: images.product5Review2,
                name: "Emma Wilson",
                date: "July 25, 2024",
                rating: 4.8,
                content: "Improved my car's performance and fuel efficiency. Highly recommended!",
            },
        ],
    },
    {
        id: 6,
        image: images.product6Gallery1,
        name: "Fire Extinguisher",
        price: 35,
        disprice: 30,
        stock: 20,
        content:
            "Ensure safety on the road with our compact and reliable Fire Extinguisher. Designed for taxi and vehicle use, it provides quick fire suppression in case of emergencies, giving drivers peace of mind.",
        description:
            "Our Fire Extinguisher is lightweight, easy to use, and meets vehicle safety standards. Ideal for small fires in taxis, it features a fast-discharge mechanism and a durable metal body. A must-have safety tool for every taxi driver.",
        category: ["Emergency Kit", "Vehicle Maintenance"],
        tags: ["Extinguisher", "Kit", "Oil"],
        gallery: {
            image1: images.product6Gallery1,
            image2: images.product6Gallery2,
            image3: images.product6Gallery3,
            image4: images.product6Gallery4,
        },
        addInfo: [
            { id: 1, title: "Type", content: "Dry Powder Fire Extinguisher" },
            { id: 2, title: "Capacity", content: "1kg" },
            { id: 3, title: "Usage", content: "Suitable for Class A, B, C Fires" },
            { id: 4, title: "Mounting", content: "Includes Vehicle Bracket" },
        ],
        comments: [
            {
                id: 1,
                image: images.product6Review1,
                name: "James Parker",
                date: "July 20, 2024",
                rating: 5,
                content: "Essential safety item for every taxi. Compact and easy to use!",
            },
            {
                id: 2,
                image: images.product6Review2,
                name: "Emma Wilson",
                date: "July 25, 2024",
                rating: 4.9,
                content: "High-quality extinguisher, fits perfectly in my taxi.",
            },
        ],
    },
    {
        id: 7,
        image: images.product7Gallery1,
        name: "GPS Device",
        price: 150,
        disprice: 135,
        stock: 15,
        content:
            "Enhance your taxi’s navigation with our high-precision GPS Device. Designed for professional drivers, it provides real-time location tracking, traffic updates, and turn-by-turn directions for a seamless driving experience.",
        description:
            "Our GPS Device is equipped with a large touchscreen display, voice-guided navigation, and offline maps for uninterrupted usage. With its smart routing features and speed limit alerts, it helps taxi drivers reach destinations efficiently and safely.",
        category: ["Tech Gadgets", "Car Accessories"],
        tags: ["GPS", "Speaker", "Holder"],
        gallery: {
            image1: images.product7Gallery1,
            image2: images.product7Gallery2,
            image3: images.product7Gallery3,
            image4: images.product7Gallery4,
        },
        addInfo: [
            { id: 1, title: "Display", content: "5-inch HD Touchscreen" },
            { id: 2, title: "Connectivity", content: "Wi-Fi & Bluetooth Enabled" },
            { id: 3, title: "Features", content: "Real-time Traffic Updates, Voice Guidance" },
            { id: 4, title: "Battery", content: "Rechargeable Lithium-ion, 6 Hours Backup" },
        ],
        comments: [
            {
                id: 1,
                image: images.product7Review1,
                name: "James Parker",
                date: "July 20, 2024",
                rating: 5,
                content: "Accurate and easy to use. Helps me find the best routes quickly!",
            },
            {
                id: 2,
                image: images.product7Review2,
                name: "Emma Wilson",
                date: "July 25, 2024",
                rating: 4.8,
                content: "Great GPS device for taxis! The real-time traffic updates are super helpful.",
            },
        ],
    },
    {
        id: 8,
        image: images.product8Gallery1,
        name: "Phone Holder",
        price: 30,
        disprice: 0,
        stock: 20,
        content:
            "Keep your phone secure and accessible while driving with our premium Phone Holder. Designed for taxi drivers, it provides a firm grip, adjustable angles, and hands-free convenience for easy navigation and calls.",
        description:
            "Our Phone Holder features a strong suction base, 360-degree rotation, and an anti-slip grip to keep your phone steady on bumpy rides. Perfect for GPS navigation, hands-free calls, and passenger ride management, making every trip smooth and hassle-free.",
        category: ["Tech Gadgets", "Car Accessories"],
        tags: ["Holder", "Speaker", "GPS"],
        gallery: {
            image1: images.product8Gallery1,
            image2: images.product8Gallery2,
            image3: images.product8Gallery3,
            image4: images.product8Gallery4,
        },
        addInfo: [
            { id: 1, title: "Mount Type", content: "Dashboard & Windshield Suction" },
            { id: 2, title: "Rotation", content: "360° Adjustable Viewing Angle" },
            { id: 3, title: "Grip", content: "Anti-Slip, Shock-Resistant Clamp" },
            { id: 4, title: "Compatibility", content: "Fits All Smartphones (4'' - 7'')" },
        ],
        comments: [
            {
                id: 1,
                image: images.product8Review1,
                name: "James Parker",
                date: "July 20, 2024",
                rating: 5,
                content: "Great quality and strong grip! Perfect for navigation while driving.",
            },
            {
                id: 2,
                image: images.product8Review2,
                name: "Emma Wilson",
                date: "July 25, 2024",
                rating: 4.7,
                content: "Very sturdy and easy to adjust. Keeps my phone secure even on rough roads.",
            },
        ],
    },
    {
        id: 9,
        image: images.product9Gallery1,
        name: "Air Freshener",
        price: 15,
        disprice: 12,
        stock: 0,
        content:
            "Keep your taxi smelling fresh and inviting with our premium Air Freshener. Designed to eliminate odors and create a pleasant atmosphere for passengers, this long-lasting freshener ensures every ride is enjoyable.",
        description:
            "Our Air Freshener is made with natural essential oils and comes in a variety of refreshing scents. With an easy-to-use design, it provides continuous freshness, neutralizing unwanted smells from food, smoke, or pets. Perfect for professional drivers who want to maintain a clean and pleasant car interior.",
        category: ["Car Accessories", "Vehicle Maintenance"],
        tags: ["Kit", "Covers", "Oil"],
        gallery: {
            image1: images.product9Gallery1,
            image2: images.product9Gallery2,
            image3: images.product9Gallery3,
            image4: images.product9Gallery4,
        },
        addInfo: [
            { id: 1, title: "Type", content: "Hanging & Vent Clip Options" },
            { id: 2, title: "Scent Options", content: "Lavender, Citrus, Ocean Breeze" },
            { id: 3, title: "Duration", content: "Lasts up to 30 Days" },
            { id: 4, title: "Ingredients", content: "Natural Essential Oils" },
        ],
        comments: [
            {
                id: 1,
                image: images.product9Review1,
                name: "James Parker",
                date: "July 20, 2024",
                rating: 5,
                content: "Keeps my taxi fresh all day! The ocean breeze scent is amazing.",
            },
            {
                id: 2,
                image: images.product9Review2,
                name: "Emma Wilson",
                date: "July 25, 2024",
                rating: 4.8,
                content: "Love the natural fragrance! My passengers always compliment the fresh smell.",
            },
        ],
    },
    {
        id: 10,
        image: images.product10Gallery1,
        name: 'Car Battery',
        price: 200,
        disprice: 185,
        stock: 15,
        content: "Power your vehicle with our high-performance AGM battery, engineered for reliable starts in extreme conditions. Featuring advanced spill-proof technology and deep-cycle capability, this battery delivers consistent power for modern vehicles with high electrical demands.",
        description: "This maintenance-free automotive battery is designed for superior performance in cars, trucks, and SUVs. With enhanced vibration resistance and optimized power output, it supports start-stop technology and provides exceptional cold cranking amps for reliable winter starts.",
        category: ["Vehicle Maintenance", "Car Accessories"],
        tags: ["Battery", "Oil", "Kit"],
        gallery: {
            image1: images.product10Gallery1,
            image2: images.product10Gallery2,
            image3: images.product10Gallery3,
            image4: images.product10Gallery4,
        },
        addInfo: [
            { id: 1, title: 'Voltage', content: '12V' },
            { id: 2, title: 'Cold Cranking Amps', content: '850 CCA' },
            { id: 3, title: 'Warranty', content: '36-Month Replacement' },
            { id: 4, title: 'Compatibility', content: 'SUV/Truck/Crossover' },
            { id: 5, title: 'Technology', content: 'AGM (Absorbent Glass Mat)' },
            { id: 6, title: 'Dimensions', content: 'L10.9" x W6.8" x H7.5"' },
        ],
        comments: [
            {
                id: 1,
                image: images.product10Review1,
                name: 'Mike Johnson',
                date: 'January 15, 2024',
                rating: 4.9,
                content: 'Survived -20°C winter perfectly in my F-150. Quick installation and great power!',
            },
            {
                id: 2,
                image: images.product10Review2,
                name: 'Sarah Thompson',
                date: 'March 2, 2024',
                rating: 5,
                content: "Best aftermarket battery I've installed. Customers love the reliability and 3-year warranty.",
            },
        ]
    },
    {
        id: 11,
        image: images.product11Gallery1,
        name: 'Seat Covers', 
        price: 220,
        disprice: 199,
        stock: 15,
        content: "Upgrade your car’s interior with our Luxury Car Seat Covers. Designed for comfort and style, these covers protect your seats from spills, stains, and wear while enhancing your driving experience. Made from premium, breathable materials, they ensure a perfect fit and long-lasting durability.",
        description: "Our Luxury Car Seat Covers are perfect for car owners looking to add elegance and protection to their vehicle. The easy-to-install design ensures a snug fit, while the soft padding provides extra comfort. Available in multiple colors and styles to match your car's interior.",
        category: ["Car Accessories", "Vehicle Maintenance"],
        tags: ["Covers", "Kit", "Battery"],
        gallery: {
            image1: images.product11Gallery1,
            image2: images.product11Gallery2,
            image3: images.product11Gallery3,
            image4: images.product11Gallery4,
        },
        addInfo: [
            { id: 1, title: 'Material', content: 'Premium Leather & Breathable Fabric' },
            { id: 2, title: 'Fit', content: 'Universal Fit for Most Car Seats' },
            { id: 3, title: 'Protection', content: 'Water-Resistant & Scratch-Proof' },
            { id: 4, title: 'Installation', content: 'Easy Slip-On Design' },
        ],
        comments: [
            {
                id: 1,
                image: images.product11Review1,
                name: 'Michael Thompson',
                date: 'August 18, 2024',
                rating: 5,
                content: 'Perfect seat covers! They fit my SUV well and add a premium touch to my car’s interior.',
            },
            {
                id: 2,
                image: images.product11Review2,
                name: 'Olivia Carter',
                date: 'August 22, 2024',
                rating: 4.9,
                content: 'Very comfortable and stylish. Installation was quick, and the material feels premium!',
            },
        ]
    },
    {
        id: 12,
        image: images.product12Gallery1,
        name: 'Tool Set', 
        price: 180,
        disprice: 0,
        stock: 0,
        content: "Be prepared for any repair with our Professional Auto Repair Tool Set. This comprehensive kit includes high-quality tools designed for precision and durability, making it perfect for both DIY car enthusiasts and professional mechanics.",
        description: "Our Professional Auto Repair Tool Set features a wide range of essential tools, including wrenches, screwdrivers, sockets, and pliers. With an ergonomic grip and a sturdy storage case, this set is ideal for automotive repairs, maintenance, and emergency roadside fixes.",
        category: ["Vehicle Maintenance", "Emergency Kit"],
        tags: ["Kit", "Battery", "Oil"],
        gallery: {
            image1: images.product12Gallery1,
            image2: images.product12Gallery2,
            image3: images.product12Gallery3,
            image4: images.product12Gallery4,
        },
        addInfo: [
            { id: 1, title: 'Material', content: 'Heavy-Duty Steel with Anti-Rust Coating' },
            { id: 2, title: 'Tools Included', content: 'Wrenches, Screwdrivers, Pliers, Sockets' },
            { id: 3, title: 'Storage', content: 'Compact & Durable Carrying Case' },
            { id: 4, title: 'Usage', content: 'Automotive Repairs & Maintenance' },
        ],
        comments: [
            {
                id: 1,
                image: images.product12Review1,
                name: 'David Reynolds',
                date: 'August 25, 2024',
                rating: 5,
                content: 'Great toolset for my garage! Has everything I need for car repairs.',
            },
            {
                id: 2,
                image: images.product12Review2,
                name: 'Sophia Mitchell',
                date: 'August 28, 2024',
                rating: 4.8,
                content: 'High-quality tools and a sturdy case. Perfect for on-the-go fixes!',
            },
        ]
    },
    {
        id: 13,
        image: images.product13Gallery1,
        name: 'Car Jack', 
        price: 180,
        disprice: 165,
        stock: 5,
        content: "Ensure safe and effortless vehicle lifting with our Heavy-Duty Hydraulic Car Jack. Designed for strength and stability, this jack is perfect for tire changes, maintenance, and emergency roadside repairs.",
        description: "Our Heavy-Duty Hydraulic Car Jack is made from reinforced steel for maximum durability and a high load capacity. The hydraulic system provides smooth and effortless lifting, while the wide base enhances stability on various surfaces. With a compact design, it fits easily in your trunk for on-the-go convenience.",
        category: ["Vehicle Maintenance", "Emergency Kit"],
        tags: ["Kit", "Covers", "Battery"],
        gallery: {
            image1: images.product13Gallery1,
            image2: images.product13Gallery2,
            image3: images.product13Gallery3,
            image4: images.product13Gallery4,
        },
        addInfo: [
            { id: 1, title: 'Material', content: 'Reinforced Heavy-Duty Steel' },
            { id: 2, title: 'Load Capacity', content: 'Up to 3 Tons (6000 lbs)' },
            { id: 3, title: 'Lifting Range', content: '5" to 20" (12cm to 50cm)' },
            { id: 4, title: 'Mechanism', content: 'Hydraulic Lift System' },
        ],
        comments: [
            {
                id: 1,
                image: images.product13Review1,
                name: 'David Robinson',
                date: 'September 15, 2024',
                rating: 5,
                content: 'Reliable and easy to use! Perfect for my garage and emergency situations.',
            },
            {
                id: 2,
                image: images.product13Review2,
                name: 'Sophia Martinez',
                date: 'September 18, 2024',
                rating: 4.8,
                content: 'Strong and stable. Lifted my SUV effortlessly!',
            },
        ]
    },
    {
        id: 14,
        image: images.product14Gallery1,
        name: 'Microfiber Cloths', 
        price: 25,
        disprice: 20,
        stock: 5,
        content: "Keep your vehicle spotless with our ultra-soft and highly absorbent Premium Microfiber Cloths. Designed for streak-free cleaning, these cloths are perfect for detailing, drying, and polishing your car.",
        description: "Our Premium Microfiber Cloths are made from high-quality fibers that trap dust, dirt, and grime without scratching the surface. Ideal for both interior and exterior cleaning, these cloths work well with water, wax, or cleaning sprays. Reusable and machine washable, they provide long-lasting performance.",
        category: ["Car Accessories", "Vehicle Maintenance"],
        tags: ["Covers", "Kit", "Oil"],
        gallery: {
            image1: images.product14Gallery1,
            image2: images.product14Gallery2,
            image3: images.product14Gallery3,
            image4: images.product14Gallery4,
        },
        addInfo: [
            { id: 1, title: 'Material', content: '80% Polyester, 20% Polyamide' },
            { id: 2, title: 'Size', content: '16" x 16" (40cm x 40cm)' },
            { id: 3, title: 'Usage', content: 'Interior & Exterior Cleaning' },
            { id: 4, title: 'Care', content: 'Machine Washable & Reusable' },
        ],
        comments: [
            {
                id: 1,
                image: images.product14Review1,
                name: 'Michael Johnson',
                date: 'October 5, 2024',
                rating: 5,
                content: 'Super soft and highly absorbent! Works great for waxing and drying.',
            },
            {
                id: 2,
                image: images.product14Review2,
                name: 'Emily Davis',
                date: 'October 8, 2024',
                rating: 4.9,
                content: 'Absolutely love these microfiber cloths! No streaks and very durable.',
            },
        ]
    },
    {
        id: 15,
        image: images.product15Gallery1,
        name: 'Floor Mats', 
        price: 60,
        disprice: 50,
        stock: 10,
        content: "Protect your car’s interior with our durable All-Weather Car Floor Mats. Designed to trap dirt, mud, and spills, these mats provide excellent coverage and easy maintenance for a cleaner ride.",
        description: "Our premium-quality Floor Mats are crafted from heavy-duty rubber and feature deep grooves to catch debris, ensuring your car stays clean in all seasons. The anti-slip backing keeps them securely in place, while the universal fit ensures compatibility with most vehicles. Easy to clean and highly durable, these mats offer the perfect blend of style and functionality.",
        category: ["Car Accessories", "Vehicle Maintenance"],
        tags: ["Covers", "Kit", "Battery"],
        gallery: {
            image1: images.product15Gallery1,
            image2: images.product15Gallery2,
            image3: images.product15Gallery3,
            image4: images.product15Gallery4,
        },
        addInfo: [
            { id: 1, title: 'Material', content: 'Heavy-Duty Rubber' },
            { id: 2, title: 'Fit', content: 'Universal for Most Vehicles' },
            { id: 3, title: 'Features', content: 'Waterproof, Anti-Slip, Easy to Clean' },
            { id: 4, title: 'Design', content: 'Deep Grooves for Maximum Dirt Trapping' },
        ],
        comments: [
            {
                id: 1,
                image: images.product15Review1,
                name: 'Daniel Thompson',
                date: 'October 12, 2024',
                rating: 5,
                content: 'Perfect fit for my SUV! Keeps my car clean and looks great.',
            },
            {
                id: 2,
                image: images.product15Review2,
                name: 'Sophia Carter',
                date: 'October 15, 2024',
                rating: 4.8,
                content: 'Durable and easy to clean! The anti-slip backing is a great touch.',
            },
        ]
    }
];

export default products;